/* tslint:disable */
/* eslint-disable */

/**
 * Discriminated union of all manually-provided document types.
 * Add new variants here as new MANUAL-only document requirements are introduced.
 */
export type PaxCheckManualDocument = PaxCheckOnwardTicketDocument;

export interface PaxCheckOnwardTicketDocument {
    type: 'onward-ticket';
    travelDate: string;
}

export function PaxCheckManualDocumentToJSON(value: PaxCheckManualDocument): object {
    switch (value.type) {
        case 'onward-ticket':
            return {
                type: value.type,
                travel_date: value.travelDate,
            };
        default:
            throw new Error(
                `Unknown manual document type: ${(value as PaxCheckManualDocument).type}`
            );
    }
}
